export const SOCIAL_LINKS = {
  github: 'https://github.com/Sithija2k03',
  linkedin: 'https://www.linkedin.com/in/sithija-dilshan-05448427b/',
  youtube: 'https://youtube.com/@sithijadilshan-23?si=cy3ij-uIu8ABN7ng',
  kaggle: 'https://www.kaggle.com/sithija4127', 
  email: 'sithijadilshan2k03@gmail.com'
};

export const CONTACT_INFO = {
  phone: '+94 76 537 8553',
  location: 'Sri Lanka',
  locationCoords: {
    lat: 6.8643517639619285, 
    lng: 79.97021663338518
  }
};

export const SERVICES = [
  {
    title: 'Data Analysis',
    description: 'Transform raw data into actionable insights using Python, R, and SQL',
    icon: '📊'
  },
  {
    title: 'Data Visualization',
    description: 'Create compelling dashboards with Tableau, Power BI, and Plotly',
    icon: '📈'
  },
  {
    title: 'Machine Learning',
    description: 'Build predictive models using scikit-learn, TensorFlow, and XGBoost',
    icon: '🤖'
  },
    {
    
    title: 'Web Application Development', 
    description: 'Create full-stack web applications using MERN Stack. Build scalable, responsive, and user-friendly applications with modern technologies.',
    icon: '💻'
  },
];

export const PERSONAL_INFO = {
  name: 'Sithija Dilshan',
  title: 'Data Science Student & Aspiring Analyst',
  email: 'sithijadilshan2k03@gmail.com',
  phone: '+94765378553',
  location: 'Maharagama, Western Province, Sri Lanka',
  cvPath: '/Sithija_Dilshan_CV.pdf' 
};